import { processSteps } from '../data/process';
import './Process.scss';

function Process() {
  return (
    <section id="process" className="process">
      <div className="container">
        <span className="section-eyebrow">Process</span>
        <h2 className="section-title">A four stage workflow that keeps projects moving</h2>
        <div className="process__grid">
          {processSteps.map((step, index) => (
            <article key={step.title} className="card process__card">
              <span className="process__step">0{index + 1}</span>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
              <span className="process__duration">Typical duration: {step.duration}</span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Process;
